import { axiosInstance } from "../axios";

export const cuaHangApi = {
  getAll: async () => {
    return await axiosInstance.get("/stores");
  },
  getMyStore: async () => {
    return await axiosInstance.get("/stores/getMyStore");
  },
};
